import type { CourseModule } from "@/core/types";
import { lektionPdfUndHandout } from "./lektion-01-pdf-und-handout";
import { lektionVorDemVersand } from "./lektion-02-vor-dem-versand";
import { lektionKursabschluss } from "./lektion-03-abschluss";

export const modulExport: CourseModule = {
  id: "export",
  title: "Export und Weitergabe",
  summary:
    "Die richtige Fassung für den jeweiligen Zweck – PDF, Handzettel, Notizenseiten, " +
    "Video –, ein sauberer Blick in die Datei vor dem Versand und die Abschlussübung " +
    "des Kurses.",
  level: "Aufbau",
  lessons: [lektionPdfUndHandout, lektionVorDemVersand, lektionKursabschluss],
};
